export default "__VITE_ASSET__6hwFrJI3__"